import { render, staticRenderFns } from "./select-malha-semanas.vue?vue&type=template&id=7b0a11e1"
import script from "./select-malha-semanas.vue?vue&type=script&lang=js"
export * from "./select-malha-semanas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports